import { render, staticRenderFns } from "./BCXSkeleton.vue?vue&type=template&id=534c0eaf&scoped=true"
import script from "./BCXSkeleton.vue?vue&type=script&lang=ts"
export * from "./BCXSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./BCXSkeleton.vue?vue&type=style&index=0&id=534c0eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c0eaf",
  null
  
)

export default component.exports